export default __webpack_public_path__ + "static/media/icon-vehicle.e2044032.svg";